import ServiceBundles from './dashboard';

export default ServiceBundles;
